<template>
  <div>
    <div v-if="logged" class="navigation">
      <div class="menuToggle" @click="$router.push({ name: routeNames.QR })" >
          <icon
            :name="'qr'"
            :color="this.$vuetify.theme.themes.light.secondary" 
            :style="'position: absolute; cursor: pointer;'"
            @click="$router.push({ name: routeNames.QR })" 
            width="50"
          ></icon>
        </div>
        <div class="menu">
          <ul>
            <li
            @click="$router.push({ name: routeNames.WALLET })" 
            :class="currentRouteName === routeNames.WALLET ? 'marked' : ''">
              <icon
                :name="'home'"
                :color="'#fff'" 
                :style="'position: absolute; cursor: pointer;'"
                width="30"
              ></icon>
            </li>
            <li
            @click="$router.push({ name: routeNames.TRANSACTIONS, params: { showTransactionsWarningModal: true }, })" 
            :class="currentRouteName === routeNames.TRANSACTIONS ? 'marked' : ''">
              <icon
                :name="'transactions'"
                :color="'#fff'" 
                :style="'position: absolute; cursor: pointer;'"
                @click="$router.push({ name: routeNames.TRANSACTIONS, params: { showTransactionsWarningModal: true }, })" 
                width="30"
              ></icon>
            </li>
            <li></li>
            <li
            @click="$router.push({ name: routeNames.TOKENS })" 
            :class="currentRouteName === routeNames.TOKENS ? 'marked' : ''">
              <icon
                :name="'tokens'"
                :color="'#fff'" 
                :style="'position: absolute; cursor: pointer;'"
                @click="$router.push({ name: routeNames.TOKENS })"
                width="30"
              ></icon>
            </li>
            <li 
            @click="$router.push({ name: routeNames.MY_ACCOUNT })"
            :class="currentRouteName === routeNames.MY_ACCOUNT ? 'marked' : ''">
              <icon
                :name="'profile'"
                :color="'#fff'" 
                :style="'position: absolute; cursor: pointer;'"
                @click="$router.push({ name: routeNames.MY_ACCOUNT })"
                width="30"
              ></icon>
            </li>
          </ul>
        </div>   
    </div>
    <div v-else class="primary d-flex justify-space-between align-center px-10" style="height: 70px; font-size: 13px; color: var(--text-over-primary);">
      <span>Copyright</span>
      <span>{{ $t("contact_information") }}</span>
    </div>
  </div>
  
</template>

<script>
  import routeNames from "@/router/route-names";

  export default{
    props: {
      logged: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        qrIcon: require('@/assets/images/qr_icon.png'),
        homeIcon: require('@/assets/images/home_icon.png'),
        tokensIcon: require('@/assets/images/tokens_icon.png'),
        transactionIcon: require('@/assets/images/transaction_icon.png'),
        profileIcon: require('@/assets/images/profile_icon.png'),
        currentRouteName: "",
        routeNames: routeNames,
      }
    },
    mounted() {
      this.currentRouteName = this.$route.name 
    },
    watch: {
      '$route.name'(newName, oldName) {
        this.currentRouteName = newName
      }
    }
  }
</script>

<style scoped>
.navigation{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}
.menuToggle{
  position: relative;
  width: 86px;
  height: 86px;
  background-color: var(--primary-color);
  border: 5px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  transform: translateY(-54px);
}
.menuToggle i{
  position: absolute;
  inset: 0;
}
.menuToggle i::before{
  content: '';
  position: absolute;
  top: 38px;
  left: -20px;
  width: 18px;
  height: 18px;
  background: transparent;
  border-top-right-radius: 20px;
  box-shadow: 3px -6px #fff;
}
.menuToggle i::after{
  content: '';
  position: absolute;
  top: 38px;
  right: -20px;
  width: 18px;
  height: 18px;
  background: transparent;
  border-top-left-radius: 20px;
  box-shadow: -3px -6px #fff;
}
.menu {
  position: absolute;
  width: 100%;
  max-width: 390px;
  height: 108px;
  background: #000230;
}

.menu ul {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  margin-top: 13px;
  gap: 0;
  height: 100%;
  line-height: 500px;
  list-style-type: none;
  padding-left: 0;
  margin-left: 0;
}
.menu ul li{
  list-style: none;
  cursor: pointer;
  padding-left: 0;
  margin-left: 0;
  position: relative;
  width: 30px;
  height: 30px;
}

.menu ul li a{
  display: block;
  font-size: 6em;
  text-decoration: none;
}
.menu ul li.marked::after{
  content: "";
  height: 8px;
  width: 8px;
  background-color: var(--primary-color);
  border-radius: 50%;
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
}
</style>